import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const PersonMonocularIcon = () => (
  <ImageIcon src={Images.PersonMonocular} alt="person-monocular/" />
);

export default PersonMonocularIcon;
